import React from 'react'
import { getECInterfaceDomain } from '../../../utils/config'
import { handleDataLayerEvent, handleGAEvent } from './googleAnalytics'
import { getAppEventName } from '../../../utils/services/googleAnalytics'
import { appConfig } from './constants'

const formatJobList = (jobs, adhesiveAnchorModel) => {
  const jobList = jobs.map((entry) => {
    const myEntry = Object.keys(entry).reduce((newEntry, key) => {
      if (key === adhesiveAnchorModel || key === 'jobName' || key === 'userInputs') {
        let value = entry[key]
        if (key === 'userInputs' && value['waterFilledHoles'] !== undefined) {
          value['waterFilledHoles'] = value['waterFilledHoles'] ? 'Yes' : 'No'
        }
        newEntry[key] = value
      }
      return newEntry
    }, {})

    return myEntry
  })
  const adhesiveAnchorTotal = jobList.reduce(
    (total, entry) => total + entry[adhesiveAnchorModel],
    0,
  )

  return [jobList, adhesiveAnchorTotal]
}

const formatScreenTubeList = (jobList) => {
  const screenTubeObj = jobList.reduce((result, item) => {
    const key = item.userInputs.screenTube
    if (key && result[key]) {
      result[key] = result[key] + parseFloat(item.userInputs.numberInstallations)
    } else if (key) {
      result[key] = parseFloat(item.userInputs.numberInstallations)
    }
    return result
  }, {})

  const screenTubeList = Object.keys(screenTubeObj).reduce((result, key) => {
    result.push({ model: key, quantity: screenTubeObj[key] })
    return result
  }, [])

  return screenTubeList
}

const formatResults = (results, adhesiveAnchorModel) => {
  return results.find((item) => item.model === adhesiveAnchorModel)
}

export const handleDowelingOrder = (output, input) => {
  const { sourceDomain, adhesiveAnchorModel, screenTube, source } = input
  let appEventName = getAppEventName(appConfig.appCode, source === 'EC')

  const parentDomain = sourceDomain ? sourceDomain : getECInterfaceDomain(window.location.hostname)
  const parentWindow = window.parent

  const { results, jobs } = output

  const resultsClone = JSON.parse(JSON.stringify(results)) // Object.assign([], results)
  const jobsClone = JSON.parse(JSON.stringify(jobs)) // Object.assign([], jobs)

  const result = formatResults(resultsClone, adhesiveAnchorModel)
  const [jobList, adhesiveAnchorTotal] = formatJobList(jobsClone, adhesiveAnchorModel)
  const screenTubeList = formatScreenTubeList(jobList)

  const screenTubes = screenTubeList.reduce((result, current) => {
    result[0].push(current.model)
    result[1].push(current.quantity)

    return result;
  }, [[], []])

  const orderedItems = [adhesiveAnchorModel].concat(screenTubes[0]).join(',')
  const orderedQuantities = [adhesiveAnchorTotal.toFixed(2)].concat(screenTubes[1]).join(',')

  const gaInput = {
    ordered_items: orderedItems,
    ordered_quantities: orderedQuantities
  }

  handleGAEvent({
    appEventName,
    gaActionName: 'Order_Button_Click',
    gaLabelName: 'Order',
    input,
  })

  handleDataLayerEvent({
    appEventName,
    appAction: 'Order_Action',
    appInputs: gaInput,
  })

  const reply = {
    type: 'aceOK',
    data: {
      result: {
        models: [
          {
            model: result.model,
            quantity: adhesiveAnchorTotal,
          },
        ].concat(screenTubeList),
      },
      jobList: jobList,
    },
  }
  parentWindow.postMessage(reply, parentDomain)
}

const formatCIResult = (output, input) => {
  const injectionResinList = output.injectionResinResults.find(
    (item) => item.model === input.injectionResinModel,
  )
  const pasteOverEpoxyList = output.pasteOverEpoxyResults.find(
    (item) => item.model === input.pasteOverEpoxyModel,
  )
  const pumpingPortsList = output.pumpingPortsResults.find(
    (item) => item.model === input.pumpingPortModel,
  )
  const injectionFittingsList = output.injectionFittingsResults.find(
    (item) => item.model === input.injectionFittingModel,
  )

  return []
    .concat(
      injectionResinList
        ? [
          {
            model: injectionResinList.model,
            quantity: injectionResinList.cartridgesNeeded,
          },
        ]
        : [],
    )
    .concat(
      pasteOverEpoxyList
        ? [
          {
            model: pasteOverEpoxyList.model,
            quantity: pasteOverEpoxyList.cartridgesNeeded,
          },
        ]
        : [],
    )
    .concat(
      pumpingPortsList
        ? [
          {
            model: pumpingPortsList.model,
            quantity: pumpingPortsList.packagesNeeded,
          },
        ]
        : [],
    )
    .concat(
      injectionFittingsList
        ? [
          {
            model: injectionFittingsList.model,
            quantity: injectionFittingsList.packagesNeeded,
          },
        ]
        : [],
    )
}

const gaFormatCIResult = (output, input) => {
  const injectionResinList = output.injectionResinResults.find(
    (item) => item.model === input.injectionResinModel,
  )
  const pasteOverEpoxyList = output.pasteOverEpoxyResults.find(
    (item) => item.model === input.pasteOverEpoxyModel,
  )
  const pumpingPortsList = output.pumpingPortsResults.find(
    (item) => item.model === input.pumpingPortModel,
  )
  const injectionFittingsList = output.injectionFittingsResults.find(
    (item) => item.model === input.injectionFittingModel,
  )

  let orderedItems = []
  let orderedQuantities = []
  let result = []
    .concat(
      injectionResinList
        ? [
          {
            model: injectionResinList.model,
            quantity: Number(injectionResinList.cartridgesNeeded.toFixed(2)),
          },
        ]
        : [],
    )
    .concat(
      pasteOverEpoxyList
        ? [
          {
            model: pasteOverEpoxyList.model,
            quantity: Number(pasteOverEpoxyList.cartridgesNeeded.toFixed(2)),
          },
        ]
        : [],
    )
    .concat(
      pumpingPortsList
        ? [
          {
            model: pumpingPortsList.model,
            quantity:
              pumpingPortsList.packageSize === '1'
                ? Math.round(pumpingPortsList.packagesNeeded)
                : Number(pumpingPortsList.packagesNeeded.toFixed(2)),
          },
        ]
        : [],
    )
    .concat(
      injectionFittingsList
        ? [
          {
            model: injectionFittingsList.model,
            quantity: injectionFittingsList.packagesNeeded,
          },
        ]
        : [],
    )

  for (const item of result) {
    orderedItems.push(item.model)
    orderedQuantities.push(item.quantity.toString())
  }

  let gaInput = {
    ordered_items: orderedItems.join(','),
    ordered_quantities: orderedQuantities.join(','),
  }

  return gaInput

}

export const handleCIOrder = (output, input) => {
  let appEventName = getAppEventName(appConfig.appCode, input.source === 'EC')
  const parentDomain = input.sourceDomain
    ? input.sourceDomain
    : getECInterfaceDomain(window.location.hostname) // location.origin
  const parentWindow = window.parent

  const result = formatCIResult(output, input)
  const inputClone = Object.assign({}, input)
  delete inputClone.validation
  delete inputClone.subApp
  delete inputClone.source
  delete inputClone.sourceDomain
  delete inputClone.injectionResinModel
  delete inputClone.pasteOverEpoxyModel
  delete inputClone.pumpingPortModel
  delete inputClone.injectionFittingModel
  if (inputClone.pasteOverBothSidesOfCrack === true) {
    inputClone.pasteOverBothSidesOfCrack = 'Yes'
  } else if (inputClone.pasteOverBothSidesOfCrack === false) {
    inputClone.pasteOverBothSidesOfCrack = 'No'
  }

  // GA
  handleGAEvent({
    appEventName,
    gaActionName: 'Order_Button_Click',
    gaLabelName: 'Order',
    input,
  })

  handleDataLayerEvent({
    appEventName,
    appAction: 'Order_Action',
    appInputs: gaFormatCIResult(output, input),
  })

  const reply = {
    type: 'aceOK',
    data: {
      result: {
        models: result,
      },
      userInputs: inputClone,
    },
  }
  parentWindow.postMessage(reply, parentDomain)
}
